// src/api/reportesApi.js
export const REPORTES_API =
  process.env.REACT_APP_REPORTES_API ||
  "https://p3mslv2vz1.execute-api.us-east-1.amazonaws.com/dev";
